export default "__VITE_ASSET__Ddil60WC__"